import React, { useState, useEffect } from 'react'

function Table(props) {
    const [editing, setEditing] = useState(false)
    const [saving, setSaving] = useState(false)
    const team = props.team

    const save = () => {}

    const addBeneficiary = () => {
        if (selectedBeneficiary) {
          setEditSponsorships((state) => [
            ...state,
            { beneficiary_id: selectedBeneficiary.id },
          ]);
          unsavedIds.push(selectedBeneficiary.id)
        }
        setSelectedBeneficiary(null)
        removeSelectOption(selectedBeneficiary)
      };

      const clearFromList = () => {
        if (unsavedIds.length == 0) return undefined
        for (let x = 0; x < unsavedIds.length; x++) {
          let id = unsavedIds[id]
          for (let j = 0; j < editSponsorships.length; j++) {
            if (id == editSponsorships[j].id) {
              addSelectOption(editSponsorships[j].id)
              editSponsorships.splice(j, 1)
            }
          }
        }
      }

      const cleanList = () => {
        setEditing(false)
        clearFromList()
        if (unsavedIds.length > 0) Alert.show("notice", `${unsavedIds.length} unsaved sponsorships has been removed from the list`)
        setUnsavedIds([])
        initializeSelectOptions()
      }


  return (
    <div id="sponsorships-table" className="card">
      <div className="card-header flex-header">
        <div>
          <h4 className="card-title">Sponsorships</h4>
        </div>
        <div>
          {editing && (
            <div>
              <button
                onClick={cleanList}
                name="button"
                className="btn btn-outline-danger mr-1"
              >
                Close
              </button>
              <button onClick={save} name="button" className="btn btn-primary">
                {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                Save
              </button>
            </div>
          )}
          {!editing && (
            <button
              onClick={() => setEditing(true)}
              className="btn btn-primary"
            >
              {" "}
              Edit {team.beneficiary_title}
            </button>
          )}
        </div>
      </div>

      {editing && (
        <div className="form-group">
          <label>{team.beneficiary_title}</label>
          <div className="input-group">
            <Select
              className="form-control select-beneficiaries"
              classNamePrefix="select-beneficiaries"
              onChange={(beneficiary) => setSelectedBeneficiary(beneficiary)}
              options={selectOptions}
              getOptionLabel={(beneficiary) =>
                `${beneficiary.first_name} ${beneficiary.last_name}`
              }
              getOptionValue={(beneficiary) => beneficiary.id}
              value={selectedBeneficiary}
            />
            <div className="input-group-append">
              <button
                onClick={() => addBeneficiary()}
                className="btn btn-primary"
              >
                Add
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="list-group list-group-flush">
        {editSponsorships.map((sponsorship) => (
          <div
            key={sponsorship.beneficiary_id}
            id={`sponsorship-beneficiary-${sponsorship.beneficiary_id}`}
            className="list-group-item"
          >
            <div className="list-group-item-body">
              <div className="list-group-item-body-main mb-2">
                <span className="mr-1">
                  {beneficiaryNameFromId(sponsorship.beneficiary_id)}
                </span>
                <a
                  href={
                    "/b/" + sponsorship.beneficiary_id + "/edit"
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fa fa-external-link"></i>
                </a>
              </div>

              {!editing &&
                sponsorship.id &&
                sponsorship.custom_fields.map((custom_field) => (
                  <div key={custom_field.custom_team_field_id}>
                    <div className="">{custom_field.name}</div>
                    <div className="font-weight-bold mb-2">
                      {custom_field.value}
                    </div>
                  </div>
                ))}
            </div>
            {editing && (
              <div className="list-group-item-actions d-none-mobile">
                {!sponsorship.id && (
                  <span className="badge badge-sm badge-warning badge-pill mr-2">
                    Not Saved
                  </span>
                )}

                {(!sponsorship.id || confirmingDeleteId != sponsorship.id) && (
                  <button
                    data-confirm="Are you sure? This can't be undone."
                    onClick={() => handleConfirmDelete(sponsorship)}
                    className="btn btn-sm btn-danger"
                  >
                    Remove
                  </button>
                )}

                {confirmingDeleteId && confirmingDeleteId == sponsorship.id && (
                  <span>
                    <button
                      onClick={() => handleDelete(sponsorship)}
                      className="btn btn-sm btn-danger mr-1"
                    >
                      Confirm Remove
                    </button>
                    <button
                      onClick={() => setConfirmingDeleteId(null)}
                      className="btn btn-sm btn-outline-danger"
                    >
                      Cancel
                    </button>
                  </span>
                )}
              </div>
            )}

            {!editing &&
              sponsorship.custom_fields.length > 0 &&
              sponsorship.id && (
                <div className="list-group-item-actions d-none-mobile">
                  <button
                    onClick={() =>
                      showCustomFieldsForm(sponsorship.beneficiary_id)
                    }
                    className="btn btn-sm btn-primary"
                  >
                    Edit Fields
                  </button>
                </div>
              )}
          </div>
        ))}

        {openCustomFieldsForm && (
          <SponsorshipForm
            sponsorship={editingSponsorship}
            openCustomFieldsForm={openCustomFieldsForm}
            setOpenCustomFieldsForm={setOpenCustomFieldsForm}
            updateSponsorship={updateSponsorship}
          />
        )}
      </div>
    </div>
  )
}

export default Table
